import React from 'react';
import { ShieldCheckIcon, TruckIcon, MapPinIcon, CreditCardIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-100 pt-12 pb-8 border-t border-gray-200" data-id="element-115">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-116">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10" data-id="element-117">
          <div className="flex flex-col items-center md:items-start" data-id="element-118">
            <div className="flex items-center mb-3" data-id="element-119">
              <ShieldCheckIcon className="h-6 w-6 text-emerald-600 mr-3" data-id="element-120" />
              <span className="text-gray-700 font-medium" data-id="element-121">
                Sichere Transaktion
              </span>
            </div>
            <p className="text-gray-600 text-sm text-center md:text-left" data-id="element-122">
              256-Bit Verschlüsselung für alle Zahlungen
            </p>
          </div>
          <div className="flex flex-col items-center" data-id="element-123">
            <div className="flex items-center mb-3" data-id="element-124">
              <TruckIcon className="h-6 w-6 text-emerald-600 mr-3" data-id="element-125" />
              <span className="text-gray-700 font-medium" data-id="element-126">
                Kostenloser Versand
              </span>
            </div>
            <p className="text-gray-600 text-sm text-center" data-id="element-127">
              Innerhalb Deutschlands & Österreich
            </p>
          </div>
          <div className="flex flex-col items-center md:items-end" data-id="element-128">
            <div className="flex items-center mb-3" data-id="element-129">
              <MapPinIcon className="h-6 w-6 text-emerald-600 mr-3" data-id="element-130" />
              <span className="text-gray-700 font-medium" data-id="element-131">
                Hergestellt in Deutschland
              </span>
            </div>
            <p className="text-gray-600 text-sm text-center md:text-right" data-id="element-132">
              Unter strengsten Qualitäts-Checks
            </p>
          </div>
        </div>
        <div className="flex flex-wrap justify-center items-center gap-4 mb-10" data-id="element-133">
          <div className="bg-white px-4 py-3 rounded-lg shadow-sm flex items-center border border-gray-200" data-id="element-134">
            <CreditCardIcon className="h-5 w-5 text-gray-500 mr-2" data-id="element-135" />
            <span className="text-gray-700 text-sm font-medium" data-id="element-136">Rechnung</span>
          </div>
          <div className="bg-white px-4 py-3 rounded-lg shadow-sm flex items-center border border-gray-200" data-id="element-137">
            <span className="text-gray-700 text-sm font-medium" data-id="element-138">PayPal</span>
          </div>
          <div className="bg-white px-4 py-3 rounded-lg shadow-sm flex items-center border border-gray-200" data-id="element-139">
            <span className="text-gray-700 text-sm font-medium" data-id="element-140">
              Mastercard
            </span>
          </div>
          <div className="bg-white px-4 py-3 rounded-lg shadow-sm flex items-center border border-gray-200" data-id="element-141">
            <span className="text-gray-700 text-sm font-medium" data-id="element-142">VISA</span>
          </div>
          <div className="bg-white px-4 py-3 rounded-lg shadow-sm flex items-center border border-gray-200" data-id="element-143">
            <span className="text-gray-700 text-sm font-medium" data-id="element-144">Klarna</span>
          </div>
          <div className="bg-white px-4 py-3 rounded-lg shadow-sm flex items-center border border-gray-200" data-id="element-145">
            <span className="text-gray-700 text-sm font-medium" data-id="element-146">Raten</span>
          </div>
        </div>
        <div className="border-t border-gray-200 pt-8 pb-4" data-id="element-147">
          <div className="text-center text-gray-600 text-sm mb-6 space-x-4" data-id="element-148">
            <a href="#" className="inline-block hover:text-emerald-600 transition-colors" data-id="element-149">
              Impressum
            </a>
            <span data-id="element-150">|</span>
            <a href="#" className="inline-block hover:text-emerald-600 transition-colors" data-id="element-151">
              Datenschutz
            </a>
            <span data-id="element-152">|</span>
            <a href="#" className="inline-block hover:text-emerald-600 transition-colors" data-id="element-153">
              AGB
            </a>
            <span data-id="element-154">|</span>
            <a href="#" className="inline-block hover:text-emerald-600 transition-colors" data-id="element-155">
              Widerrufsrecht
            </a>
          </div>
          <div className="text-center text-gray-500 text-xs" data-id="element-156">
            © 2025 eve nutrition. Alle Rechte vorbehalten.
          </div>
        </div>
      </div>
    </footer>;
}